"use client";
import { useEffect, useState } from "react";

export default function Maps() {
  const [mapSrc, setMapSrc] = useState(
    "https://mapa-cazetv.vercel.app/mapa-rj",
  );

  useEffect(() => {
    const state = window.localStorage.getItem("state");

    setMapSrc(
      state === "SP"
        ? "https://casa-cazetv-mapa.vercel.app/mapa-sp"
        : "https://casa-cazetv-mapa.vercel.app/mapa-rj",
    );
  }, []);

  return (
    <section
      className="games-section reveal-up lg:min-h-lvw min-h-screen"
      id="programacao"
      style={{ backgroundColor: "#fbf1ec", paddingTop: 85 }}
    >
      <div className="flex justify-center flex-col">
        <iframe
          src={mapSrc}
          className="w-[100%] h-full lg:min-h-[103lvw] min-h-screen pl-2 pr-2 lg:pl-10 lg:pr-10"
        />
      </div>

      <style jsx>{`
        .games-section {
          min-height: 560px;
          // background: var(--brand-blue);
          background: white;
          padding: 64px 0 64px;
          color: white;
          scroll-margin-top: 6.5rem;
        }

        .games-content {
          display: grid;
          justify-items: center;
          gap: 26px;
          text-align: center;
        }

        .games-content h2 {
          max-width: 760px;
        }

        .games-content p {
          max-width: 560px;
          line-height: 1.7;
          font-size: 16px;
        }

        .match-list {
          width: min(720px, 100%);
          display: grid;
          gap: 10px;
          margin: 12px 0 38px;
        }

        .match-item {
          min-height: 52px;
          display: flex;
          align-items: center;
          justify-content: space-between;
          gap: 16px;
          border-bottom: 1px solid rgba(254, 200, 34, 0.38);
          color: var(--brand-yellow);
          text-transform: uppercase;
        }

        .match-item span {
          font-weight: 950;
          color: white;
          opacity: 0.75;
        }

        .match-item strong {
          font-size: clamp(18px, 4vw, 32px);
          line-height: 1;
          font-weight: 950;
          text-align: right;
        }

        @media (max-width: 640px) {
          .games-section {
            padding: 52px 0 60px;
          }

          .match-item {
            align-items: flex-start;
            flex-direction: column;
            padding: 12px 0;
          }

          .match-item strong {
            text-align: left;
          }
        }
      `}</style>
    </section>
  );
}
